<template>
    <div>
        <div class="content-box first">
            <RsStep class="full m-b-8" :active="2" :steps="['发起分账', '确认并签署合同', '完成分账']"></RsStep>
            <div class="status">
                <h5>完成分账</h5>
                <p>
                    分账通知给{{ info.toCpRealName }} ({{ info.toCpPhoneNum }})
                    <el-tag v-if="info.smsStatus == 1" type="success">已发送</el-tag>
                    <el-tag v-else type="info">
                        <i class="el-icon-loading"></i>
                        未发送
                    </el-tag>
                </p>
                <div style="text-align: center; margin-top: 30px">
                    <el-button type="info" @click="$router.push({path: '/manage/distribute/initiate'})">返回列表</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getSplitResults} from '@/api/distribute';
export default {
    data() {
        return {
            info: {},
        };
    },
    computed: {},
    mounted() {
        this.getInfo();
    },
    methods: {
        async getInfo() {
            const {ruleId} = this.$route.query;
            if (!ruleId) return;
            const respnose = await getSplitResults(ruleId);
            const {state, msg, result} = respnose.data;
            if (!state) return this.$message.error(msg || '获取数据失败,请重试');
            this.info = result;
            if (result.smsStatus == 1) return;
            await new Promise((resolve) => setTimeout(resolve, 4000));
            this.getInfo();
        },
    },
};
</script>
<style lang="scss" scoped>
.status {
    width: 300px;
    margin: 0 auto;
    text-align: center;
    padding: 100px 0;

    h5 {
        font-size: 24px;
        color: $-text-950;
        line-height: 24px;
    }
    p {
        color: $-text-600;
        margin-top: 16px;
        line-height: 14px;
        margin-bottom: 40px;
    }
}
</style>
